import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import useWindowDimensions from 'app/common/hooks/useWindowDimensions';
import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { NoteEvent } from 'app/model/SOL49';

class NoteColumn extends ManagedColumn<NoteEvent> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: NoteEvent) => any,
        extra?: ManagedColumnExtra<NoteEvent>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export class StandardNoteColumn {
    public static readonly TYPE = new NoteColumn('TYPE', '5em', note => note.type);
    public static readonly TITLE = new NoteColumn('TITLE', '15em', note => note.title);
    public static readonly FMPS = new NoteColumn('FMP', '8em', note => note.fmps?.join(' '), {
        wordWrapEnabled: true,
    });
    public static readonly TVS = new NoteColumn('TFV', '8em', note => note.tvs?.join(' '), {
        wordWrapEnabled: true,
    });
    public static readonly MEASURES = new NoteColumn('MEASURE', '8em', note => note.measures?.join(' '), {
        wordWrapEnabled: true,
    });
    public static readonly STATUS = new NoteColumn('STATUS', '10em', note => note.status);
}

export const NOTE_SELECTED_COLUMN = new NoteColumn(
    '',
    '2em',
    () => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

export const NoteColumns = [
    NOTE_SELECTED_COLUMN,
    StandardNoteColumn.TYPE,
    StandardNoteColumn.TITLE,
    StandardNoteColumn.FMPS,
    StandardNoteColumn.TVS,
    StandardNoteColumn.MEASURES,
    StandardNoteColumn.STATUS,
];

class NoteTableBase extends ManagedTable<NoteEvent> {}

const NoteTable = (props: ManagedTableProps<NoteEvent>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <NoteTableBase fontSize={fontSize} {...props} />;
};

export default NoteTable;
